import * as React from 'react';
import { useHistory, useRouteMatch, Route } from 'react-router';
import QuickSearchPage from './QuickSearchPage';

export interface QuickSearchPageRouterProps {}

const QuickSearchPageRouter: React.FC<QuickSearchPageRouterProps> = ({}) => {
  const history = useHistory();
  const match = useRouteMatch();

  return (
    <Route
      path={`${match.url}/:projectId?/:requestId?`}
      render={(routeProps) => (
        <QuickSearchPage
          requestId={
            routeProps.match.params.requestId ? +routeProps.match.params.requestId : undefined
          }
          projectId={
            routeProps.match.params.projectId ? +routeProps.match.params.projectId : undefined
          }
          setRequest={(id, projectId) => history.push(`${match.url}/${projectId}/${id}`)}
        />
      )}
    />
  );
};

export default QuickSearchPageRouter;
